interface InfoBoxProps {
  infoBoxHtml: string;
}

export default function InfoBox({ infoBoxHtml }: InfoBoxProps) {
  return (
    <div id="infoBox" dangerouslySetInnerHTML={{ __html: infoBoxHtml }}></div>
  );
}
